<script>
  import { canUseWebP } from '/helper'

  export let image, image2x, imageWebp, imageWebp2x
  export let category = null

</script>

<div class="container">
  <img 
    src={image} 
    srcset={canUseWebP() ? `${imageWebp} 1x, ${imageWebp2x} 2x` : `${image} 1x, ${image2x} 2x`}
  />

  {#if category}
    <h2 class="top">{category}</h2>
  {/if}
</div>

<style lang="scss">

  .container {
    position: relative;
  }
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: block;
  }

  .top {
    @include typo-serif-small-caps-28;
    color: $color-mint;
    min-height: 1em;
    margin-top: 18px;

    position: absolute;
    width: 100%;
    top:0;
    left:0;
    text-align: center;
  }

</style>